import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { memo } from "react";
import { ButtonBase } from "./ButtonBase";
import { ColorsProvider } from "../providers/ColorsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
export const toggleButtonClasses = {
    root: "MinervaToggleButton-root",
    selected: "MinervaToggleButton-selected",
    disabled: "MinervaToggleButton-disabled",
};
export const ToggleButton = memo((props) => {
    const { value, color = "surface", colorSet, invertColors, className, disabled, sx, ...rest } = useDefaultProps({ props, component: "ToggleButton" });
    return (_jsx(ColorsProvider, { color: disabled ? "disabled" : color, colorSet: colorSet, invertColors: invertColors, children: ({ color, background }) => (_jsx(ButtonBase, { disabled: disabled, className: clsx([
                className,
                toggleButtonClasses.root,
                disabled && toggleButtonClasses.disabled,
                `${toggleButtonClasses.selected}-${value}`,
            ]), sx: mergeSx({
                background: color,
                color: background,
                borderRadius: (theme) => theme.radius.default,
                padding: 1,
            }, sx), ...rest })) }));
});
//# sourceMappingURL=ToggleButton.js.map